import { Card, Flex, Heading, Paragraph, ShowHide, Spacer, Text } from '@zillow/constellation';
import { ApplicationStatus, type ApplicationStatusHistory, type RentalApplication } from '../../../graphql/queries';
import { compareDesc } from 'date-fns';
import React from 'react';
import { formatDate } from '../../../utils/formatters';
import { ConditionalApprovalPopper } from '../../Poppers/ConditionalApprovalPopper';
import { APPLICATION_STATUS_LABELS } from '../../../constants/statuses';

interface Props {
  application: RentalApplication;
}

export function ApplicationStatusHistory({ application }: Props) {
  if (!application.statusHistory) {
    return null;
  }
  const sortedStatuses = [...application.statusHistory].sort((a, b) => {
    const dateA = new Date(a?.date || '');
    const dateB = new Date(b?.date || '');
    return compareDesc(dateA, dateB);
  });
  const historicalStatuses = sortedStatuses.slice(1);
  return (
    sortedStatuses?.length > 0 && (
      <Card cardElevation={0} cardType="secondary">
        <Flex>
          <Heading level={6} as="h3">
            Current status
          </Heading>
          {sortedStatuses?.length > 1 ? (
            <ShowHide appearance="block">
              <>
                {sortedStatuses[0] && <ApplicationStatusDisplay status={sortedStatuses[0]} />}
                {historicalStatuses?.length > 0 && (
                  <ShowHide.Hidden>
                    {historicalStatuses.map((status) =>
                      status ? <ApplicationStatusDisplay status={status} key={status?.date} /> : null,
                    )}
                  </ShowHide.Hidden>
                )}
                <Spacer marginBottom="sm" />
              </>
            </ShowHide>
          ) : (
            sortedStatuses[0] && <ApplicationStatusDisplay status={sortedStatuses[0]} />
          )}
        </Flex>
      </Card>
    )
  );
}

function ApplicationStatusDisplay({ status }: { status: ApplicationStatusHistory }) {
  return (
    <Flex marginTop="sm">
      <Flex display="flex">
        <Paragraph fontType="bodySmall" marginRight="xxs">
          {status?.status}
        </Paragraph>
        {status.status === APPLICATION_STATUS_LABELS[ApplicationStatus.conditionally_approved] && (
          <ConditionalApprovalPopper marginTop="xxs" />
        )}
      </Flex>
      {status?.date && <Text fontType="finePrint">{formatDate(status?.date)}</Text>}
    </Flex>
  );
}
